import jwtDecode from "jwt-decode";
import { User } from "../interfaces/User";

export const getToken = (): string | null => {
  return localStorage.getItem("token");
};

export const getRefreshToken = (): string | null => {
  return localStorage.getItem("refreshToken");
};

export const setToken = (token: string): void => {
  localStorage.setItem("token", token);
};

export const removeToken = (): void => {
  localStorage.removeItem("token");
};

export const isTokenExpired = (): boolean => {
  const token = getToken();
  if (token) {
    const decodedToken: { exp: number } = jwtDecode(token);
    const currentTime: number = Math.floor(Date.now() / 1000); // Convert to seconds
    return decodedToken.exp < currentTime;
  }
  return true; // Token is not present or expired
};

export const isUserAdmin = (user: User | null): boolean => {
  return user?.user_level === 5;
};


export const hasPermission = ({
  userPermissions,
  module,
  permissionList,
  feature
}: {
  userPermissions: Record<string, string>;
  module: string;
  permissionList: string[];
  feature?: string;
}): boolean => {
  const modulePermission = userPermissions[module];

  if (feature === 'Accessible') return true;

  if (!modulePermission || modulePermission === 'none') return false;
  if (modulePermission === '*') return true;

  const grantedPermissions = modulePermission.split(',').map(p => p.trim());

  return permissionList.some(p => grantedPermissions.includes(p));
};